import React from 'react';
import keycloak from 'Keycloak.js';

const Label = ({ label, subLabel, linkText, fileCode, required }) => {
  return (
    <div className="drag-label">
      {label}{' '}{required && <span className="color-red"> *</span>}
      {subLabel && (
        <span className="sublabel">
          ({subLabel}
          {linkText && (
            <a
              className="sublabel-link"
              href={`${window.location.protocol}//${window.location.hostname}${process.env.REACT_APP_BACKEND_HOST_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}` + keycloak.adjustEndpoint(`/staticTemplates/${fileCode}`)}
              target="_blank"
              rel="noreferrer"
            >
              {linkText}
            </a>
          )}
          )
        </span>
      )}
    </div>
  );
};

export default Label;
